/* eslint-disable no-console */

/**
 * @file
 * Old AMD key: `ac/jira/date-picker-utils`
 */

import noop from 'lodash/noop';
import { type CallbackFn, loadCalendarResources } from './calendar-resource';
import type { DatePickerOptions } from './types';

const DEFAULT_DATEPICKER_CONFIG = {
	dateFormat: '%e/%b/%y',
	dateTimeFormat: '%e/%b/%y %I:%M %p',
	timeFormat: '12',
	firstDay: 1,
	useISO8601WeekNumbers: false,
};

let fetchDatePickerConfigPromise: Promise<typeof DEFAULT_DATEPICKER_CONFIG> | null = null;

function fetchDatePickerConfig() {
	return fetch('/rest/internal/latest/connect/data/datepicker')
		.then((response) => response.json())
		.catch(() => DEFAULT_DATEPICKER_CONFIG);
}

function initCal() {
	const initCalendarPromise = new Promise((resolve) => {
		// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
		loadCalendarResources(resolve as CallbackFn);
	});

	if (fetchDatePickerConfigPromise === null) {
		fetchDatePickerConfigPromise = fetchDatePickerConfig();
	}

	return Promise.all([fetchDatePickerConfigPromise, initCalendarPromise]).then(
		(results) => results[0],
	);
}

function initAndShow(params: DatePickerOptions) {
	initCal()
		// @ts-expect-error TS2683: 'this' implicitly has type 'any' because it does not have a type annotation.
		// eslint-disable-next-line @typescript-eslint/no-invalid-this
		.then(showInternal.bind(this, params))
		.catch(console.error);
}

function showInternal(params: DatePickerOptions, config: unknown) {
	// @ts-expect-error TS2304: Cannot find name 'calendar'.
	let cal = window.calendar;
	// patch firstDayOfWeek, JIRA does not provide default value for all the locales and calendar is not
	// working properly without one, so let's use Monday as a default when JIRA does not have default.

	// @ts-expect-error TS2304: Cannot find name 'Calendar'.
	const firstDayOfWeekDefault = Calendar._FD ? undefined : 1;
	if (cal) {
		cal.hide();
	}

	let finalParams = params || {};
	finalParams = Object.assign(finalParams, config, {
		singleClick: 'true',
		inputField: {},
	});

	// Exposing this as a global variable in order for JIRA to recognize it properly as its calendar control.
	// This way it will be able to hide it when showing other calendars (e.g. for the date picker).

	// @ts-expect-error TS2304: Cannot find name 'Calendar'.
	cal = new Calendar(
		// Either use ISO week numbers or pass undefined so the component can decide based on locale
		// ISO8601 assumes that first day of week is Monday
		finalParams.useISO8601WeekNumbers ? 1 : firstDayOfWeekDefault,
		finalParams.date,
		new Date().toISOString(),
		// Replace with lodash/noop

		finalParams.onSelect || noop,
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		(calParam: any) => {
			calParam.hide();
			calParam.destroy();
		},
	);

	// @ts-expect-error TS2304: Cannot find name 'calendar'.
	window.calendar = cal;

	cal.weekNumbers = true;
	cal.showsOtherMonths = false;
	cal.params = finalParams;
	cal.showsTime = finalParams.showTime;
	cal.time24 = finalParams.timeFormat === '24';
	const formatString = finalParams.showTime ? finalParams.dateTimeFormat : finalParams.dateFormat;
	cal.setDateFormat(formatString);

	cal.create();
	cal.refresh();
	cal.showAt(finalParams.position.left || 0, finalParams.position.top || 0);

	return cal;
}

export const show = initAndShow;
